module.exports = __webpack_public_path__ + "img/sxwt1.80f8ee0a.png";